<div class="row">
  <div class="col-md-6">
    <form #lpgDistEntry="ngForm" class="form-horizontal">
      <div class="card card-body">
        <div class="row">
          <div class="col-md-6">
            <app-material-date-range
              id="loadingDate"
              [singleDateSelector]="true"
              [(dateRange)]="selectedDate"
              [disabled]="mode === 'edit' || mode === 'niopdc'"
              [jalali]="true">
            </app-material-date-range>
          </div>
          <div class="col-md-6">
            <app-material-organisation-selector
              class="pg-component"
              [(ngModel)]="company"
              [organisationLanguage]="'fa'"
              name="organisation"
              [organisations]="organisations"
              [disabled]="mode === 'edit' || mode === 'niopdc'"
              [placeholder]="'شرکت'"
              [required]="true">
            </app-material-organisation-selector>
          </div>
        </div>
        <div class="form-group row ">
          <app-material-pg-input
              label="شماره بارنامه"
              [disabled]="mode==='edit'"
              type="text"
              name="loadingBillNumber"
              id="loadingBillNumber"
              [ngModel]="lpgDistData?.billOfLadingNumber"
              (ngModelChange)="lpgDistData.billOfLadingNumber = $event"
              [required]="true">
          </app-material-pg-input>
        </div>
        <div class="form-group row">
          <app-material-organisation-selector
            id="source2"
            class="pg-component"
            [(ngModel)]="source"
            [organisationLanguage]="'fa'"
            name="source2"
            [organisations]="sources"
            [disabled]="mode === 'edit' || mode === 'niopdc'"
            [placeholder]="'مبدا'"
            [required]="true">
          </app-material-organisation-selector>
        </div>
        <div class="form-group row ">
          <app-material-auto-complete
            [formatter]="truckValueFormatter"
            [(ngModel)]="truck"
            [items]="trucks"
            [placeholder]="'شماره کشنده'"
            name="truck"
            [required]="true">
          </app-material-auto-complete>
        </div>
        <div class="row">
          <div class="col-md-6">
            <app-material-organisation-selector
              id="primaryDestination"
              class="pg-component"
              [(ngModel)]="primaryDestination"
              [organisationLanguage]="'fa'"
              (click)="changeDestination()"
              name="primaryDestination"
              [placeholder]="'مقصد ابتدایی'"
              [organisations]="destinations"
              [required]="true">
            </app-material-organisation-selector>
          </div>
          <div class="col-md-6">
            <app-material-organisation-selector
              id="destination2"
              class="pg-component"
              [(ngModel)]="destination"
              [organisationLanguage]="'fa'"
              name="destination2"
              [organisations]="destinations"
              [placeholder]="'مقصد'"
              [required]="true">
            </app-material-organisation-selector>
          </div>
        </div>
        <div class="form-group row ">
          <app-material-pg-input
              label="وزن"
              type="text"
              name="weight"
              id="weight"
              [disabled]="mode === 'edit' || mode === 'niopdc'"
              [ngModel]="(lpgDistData?.loadingWeight)"
              (ngModelChange)="lpgDistData.loadingWeight = $event"
              [required]="true">
          </app-material-pg-input>
        </div>
        <div class="form-group row ">
          <mat-form-field>
            <mat-label> توضیحات</mat-label>
            <textarea
              matInput
              name="comment"
              id="comment"
              rows="1"
              [ngModel]="(lpgDistData?.comments)"
              (ngModelChange)="lpgDistData.comments = $event">
            </textarea>
          </mat-form-field>
        </div>
          <div class="form-group row">
            <label for="isDeleted" class="col-form-label col-md-4 ">
              حذف شده</label>
              <mat-checkbox
                class=" col-md-4 "
                type="checkbox"
                id="isDeleted"
                name="isDeleted"
                [ngModel]="(lpgDistData?.isDeleted)"
                (ngModelChange)="lpgDistData.isDeleted = $event">
              </mat-checkbox>
          </div>
        <div class="form-group row">
          <div class="col-md-12">
            <button
              mat-stroked-button
              name="pay"
              class="pull-right"
              (click)="onSubmit()"
              [disabled]="!lpgDistEntry.form.valid">
              Save
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
